import { Status } from "commonModule/services/common"

export function statusToCode(status: Status): number {
  switch (status) {
    case Status.OK: {
      return 200
    }
    case Status.INVALID_REQUEST: {
      return 400
    }
    case Status.UNAUTHORIZED: {
      return 401
    }
    case Status.REQUEST_DENIED: {
      return 403
    }
    case Status.NOT_FOUND: {
      return 404
    }
    case Status.EXPECTATION_FAILED: {
      return 417
    }
    case Status.UNKNOWN_ERROR: {
      return 500
    }
    default: {
      return 200
    }
  }
}
